export default __webpack_public_path__ + "static/media/takephoto.7d8f9439.png";